<template>
  <router-link
    :to="localedTo"
    :tag="tag"
    :exact="exact"
    :append="append"
    :replace="replace"
    :activeClass="activeClass"
    :exactActiveClass="exactActiveClass"
    :event="event"
  ><slot></slot></router-link>
</template>

<script>
export default {
  name: 'router-link-localed',
  props: [
    'to', 'tag', 'exact', 
    'append', 'replace', 'activeClass', 
    'exactActiveClass', 'event'
  ],
  computed: {
    localedTo: function() {
      return typeof this.to == 'string' 
        ? this.localedURL(this.to) 
        : this.to;
    }
  }
}
</script>